import { lazy } from "react";
import { FunctionComponent } from "react";
import {
  BarChart2,
  Book,
  CornerUpLeft,
  DollarSign,
  FileText,
  // Gift,
  Grid,
  Home as HomeIcon,
  Icon,
  Layers,
  Pocket,
  ShoppingBag,
  ShoppingCart,
  Shuffle,
  Trash2,
  UserCheck,
  Users,
} from "react-feather";
import { GET_ALL_FILTERED_RETURN_SALES_IS_DEFECTIVE, GET_RETURN_SALES_IS_DEFECTIVE } from "./../pages/returnSales/queries";

const Home = lazy(() => import("../pages/home"));
const Money = lazy(() => import("../pages/money"));
const MoneyReceipts = lazy(() => import("../pages/moneyReceipts"));
const wMoney = lazy(() => import("../pages/returnMoney"));
const Purchase = lazy(() => import("../pages/purchases"));
const Reports = lazy(() => import("../pages/reports"));
const Sale = lazy(() => import("../pages/sales"));
const SaleStorage = lazy(() => import("../pages/SaleStorage"));
const purchasesStorage = lazy(() => import("../pages/purchasesStorage"));
const Counterparties = lazy(() => import("../pages/counterparties"));
const Products = lazy(() => import("../pages/products"));
const Residues = lazy(() => import("../pages/residues"));
const Warehouses = lazy(() => import("../pages/warehouses"));
const Factories = lazy(() => import("../pages/factories"));
const Showcases = lazy(() => import("../pages/showcases"));
const Managers = lazy(() => import("../pages/managers"));
const Trash = lazy(() => import("../pages/trash"));
const ReturnSales = lazy(() => import("../pages/returnSales"));
const ReturnPurchases = lazy(() => import("../pages/returnPurchases"));

export function ReturnSalesIsDefective() {
  return (
    <ReturnSales
      isDefective
      hasPhoto
      pageName="returnSalesIsDefective"
      exportQuery={GET_ALL_FILTERED_RETURN_SALES_IS_DEFECTIVE}
      isDefectiveQuery={GET_RETURN_SALES_IS_DEFECTIVE}
    />
  );
}

export interface MenuItem {
  icon: Icon;
  component?: FunctionComponent<any>; //TODO add components
  title: string;
  seoTitle: string;
  route: string;
  link?: string | "";
}
const menuItems: MenuItem[] = [
  {
    icon: HomeIcon,
    component: Home,
    title: "home",
    seoTitle: "home",
    route: "/",
  },
  {
    icon: Pocket,
    component: Sale,
    title: "Продажа",
    seoTitle: "Продажа",
    route: "/sales",
  },
  {
    icon: Pocket,
    component: SaleStorage,
    title: "Склад Продажи",
    seoTitle: "Склад Продажи",
    route: "/wSales",
  },
  // {
  //   icon: Pocket,
  //   component: Sale,
  //   title: "sale",
  //   seoTitle: "sale",
  //   route: "/sales",
  // },
  {
    icon: ShoppingBag,
    component: Purchase,
    title: "purchase",
    seoTitle: "purchase",
    route: "/purchases",
  },
  {
    icon: ShoppingBag,
    component: purchasesStorage,
    title: "wPurchases",
    seoTitle: "wPurchases",
    route: "/wPurchases",
  },
  {
    icon: CornerUpLeft,
    title: "returnSale",
    seoTitle: "returnSale",
    route: "/returnSales",
    component: ReturnSales,
  },
  {
    icon: CornerUpLeft,
    title: "returnPurchase",
    seoTitle: "returnPurchase",
    route: "/returnPurchases",
    component: ReturnPurchases,
  },
  {
    icon: Shuffle,
    title: "defects",
    seoTitle: "defects",
    route: "/defects",
    component: ReturnSalesIsDefective,
  },
  // {
  //   icon: Gift,
  //   title: "Скидки",
  //   seoTitle: "Скидки",
  //   component: Discounts,
  //   route: "/discounts",
  // },
  {
    icon: Grid,
    title: "goods",
    seoTitle: "goods",
    component: Products,
    route: "/products",
  },
  // {
  //   icon: Percent,
  //   title: "discounts",
  //   seoTitle: "discounts",
  //   component: DiscountedProducts,
  //   route: "/discountedProducts",
  // },
  {
    icon: ShoppingCart,
    title: "residues",
    seoTitle: "residues",
    route: "/residues",
    component: Residues,
  },
  {
    icon: DollarSign,
    component: Money,
    title: "money",
    seoTitle: "money",
    route: "/moneys",
  },
  {
    icon: DollarSign,
    component: MoneyReceipts,
    title: "moneyReceipts",
    seoTitle: "moneyReceipts",
    route: "/moneyReceipts",
  },
   {
    icon: DollarSign,
    component: wMoney,
    title: "wMoney",
    seoTitle: "wMoney",
    route: "/wmoneys",
  },
  {
    icon: Users,
    title: "counterparties",
    seoTitle: "counterparties",
    route: "/counterparties",
    component: Counterparties,
  },
  {
    icon: Layers,
    component: Warehouses,
    title: "warehouses",
    seoTitle: "warehouses",
    route: "/warehouses",
  },
  {
    icon: Book,
    title: "showcases",
    seoTitle: "showcases",
    route: "/showcases",
    component: Showcases,
  },
  {
    icon: BarChart2,
    title: "factories",
    seoTitle: "factories",
    route: "/factories",
    component: Factories,
  },


  {
    icon: UserCheck,
    title: "managers",
    seoTitle: "managers",
    route: "/managers",
    component: Managers,
  },
  // {
  //   icon: Tool,
  //   title: "Контроль",
  //   seoTitle: "Контроль",
  //   component: Control,
  //   route: "/control",
  // },
  {
    icon: FileText,
    component: Reports,
    title: "reports",
    seoTitle: "reports",
    route: "/reports/:name?",
    link: "/reports",
  },
  {
    icon: Trash2,
    title: "trash",
    seoTitle: "trash",
    route: "/trash",
    component: Trash,
  },

];

export default menuItems;
